import { z } from 'zod';

/**
 * Contrato das rotas **públicas** (`/v1/publico/*`, sem autenticação,
 * rate-limited — SPEC §8 "Público" / §10).
 *
 * Só dados **não sensíveis**: nunca telefone, documento, e-mail ou qualquer
 * lista. `loja.nome` vem de `EMPRESA_NOME` (env), fonte única (SPEC §4).
 */

/**
 * Resposta de `GET /v1/publico/indicacao/:codigo` — alimenta a `LandingConvite`
 * (`/conexao-varga/convite?codigo=`). Código inexistente ou inativo **não vaza**:
 * devolve 200 com `indicadorPrimeiroNome: null` e `brindeIndicadoDescricao: null`
 * (a landing cai para "Bem-vindo à Varga Car Service", DESIGN-FOUNDATION §6.7 —
 * é enumeração de código alheio, não se revela que "não existe").
 */
export const publicoIndicacaoRespostaSchema = z.object({
  /** primeiro nome do indicador — `null` quando o código não personaliza a landing */
  indicadorPrimeiroNome: z.string().nullable(),
  /** `configuracao.brinde_indicado_descricao` — `null` na versão sem personalização */
  brindeIndicadoDescricao: z.string().nullable(),
  loja: z.object({
    /** `EMPRESA_NOME` (env) — fonte única, não vem de `configuracao` */
    nome: z.string(),
    bairro: z.string().nullable(),
    endereco: z.string().nullable(),
    horario: z.string().nullable(),
    /** E.164 — botão "falar no WhatsApp" da landing */
    whatsapp: z.string().nullable(),
    descricaoCurta: z.string().nullable(),
  }),
});
export type PublicoIndicacaoResposta = z.infer<typeof publicoIndicacaoRespostaSchema>;

/**
 * Resposta de `GET /v1/publico/configuracao` — mapa `chave -> valor` só com as
 * chaves da allowlist `CHAVES_CONFIGURACAO_PUBLICAS`. Alimenta o `AvisoCampanha`
 * sem exigir login.
 */
export const publicoConfiguracaoRespostaSchema = z.record(z.string(), z.string());
export type PublicoConfiguracaoResposta = z.infer<typeof publicoConfiguracaoRespostaSchema>;
